/**
 * List of abusive words
 */
export default [
  'लौड़ा',
  'चढ़ेगी',
  'लेगी',
  'चुदाई',
  'चूची',
  'chuchi',
  'चुची',
  'chuchee',
  'chod',
  'choot',
  'penis',
  'पेनिस',
  'lund',
  'लण्ड',
  'choos',
  'चूस',
  'degi',
  'देगी',
  'laude',
  'लौड़े',
  'tatte',
  'टट्टे',
  'behenchod',
  'बहनचोद',
  'Bhosadike',
  'भोसड़ीके',
  'sex',
  'सेक्स',
  'chudegi',
  'चूत',
  'chudai',
  'चुदाई',
  'chut',
  'छूट',
  'pussy',
  'चूत',
  'पुसी',
  'chutiya',
  'chutia',
  'चूतिया',
  'chudan',
  'चुदान',
  'gandu',
  'गांडू',
  'gand',
  'गांड',
  'gaand',
  'jhaat',
  'झाट',
  'chutad',
  'bob',
  'vegene',
  'legi',
  'ghand',
  'maa',
  'behen',
  'beti',
  'चूतड़',
  'chudie',
  'चुदाई',
  'boobs',
  'बूब्स',
  'tits',
  'टिट्स',
  'nipple',
  'निप्पल',
  'buble',
  'बब्ले',
  'दबादे',
  'भोसड़ा',
  'रंडी',
  'randi',
  'randee',
  'कुतिया',
  'kutiya',
  'छेद',
  'साली',
  'salee',
  'कुत्ती',
  'kuttee',
  'kuttii',
  'रांड',
  'चूतिया',
  'छिनाल',
  'छेद',
  'रंडीपन',
  'बेटीचोद',
  'मादरचोद',
  'चुद',
  'मुँह',
  'boob',
  'fuck',
  'fuck',
  'show',
  'lick',
  'motherfucker',
  'bhosdike',
  'matherchod',
  'maderchod',
  'rand',
  'kutti',
  'raand'
]
